module.exports = __webpack_public_path__ + "759aff8fe58ce01a026dc940a74fbb45.svg";